export const oktaSharedConfig = {
    authorize: 'https://sso.nhatest.com/oauth2/default/v1/authorize',
    userInfo: 'https://sso.nhatest.com/oauth2/default/v1/userinfo',
    token: 'https://sso.nhatest.com/oauth2/default/v1/token',
}
